import * as React from 'react';
import cx from "classnames";

import Modal from '@mui/material/Modal';

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ContactForm from "../../pages/main/components/ContactForm";

import ButtonPrimary from "../button-primary/ButtonPrimary";
import ArrowBg from "../arrow-bg/ArrowBg";

import styles from './RequestModal.module.scss';

type ResultScreenProps = {
    handleClose: () => void;
};

type RequestModalProps = {
    open: boolean;
    handleClose: () => void;
    hasComment?: boolean;
};

const SuccessScreen = ({handleClose}: ResultScreenProps) => {

    return (
        <div className={styles.successScreen}>
            <Row className="justify-content-center">
                <Col xs={12}>
                    <h2 className={styles.subtitle}>Спасибо!</h2>
                    <p className={styles.text}>Ваша заявка принята. Благодарим за&nbsp;интерес к&nbsp;нашему сервису. Мы&nbsp;отправим уведомление, как только демо-версия будет доступна.</p>
                </Col>
            </Row>
            <Row>
                <Col lg={{ span: 6, offset: 6 }}>
                    <ButtonPrimary type="submit" className={styles.buttonClose} onClick={handleClose}>
                        <>
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.5 6.41L18.09 5L12.5 10.59L6.91 5L5.5 6.41L11.09 12L5.5 17.59L6.91 19L12.5 13.41L18.09 19L19.5 17.59L13.91 12L19.5 6.41Z" fill="currentColor" />
                            </svg>
                            <span>Закрыть</span>
                        </>
                    </ButtonPrimary>
                </Col>
            </Row>
        </div>
    );
}

const ErrorScreen = ({handleClose}: ResultScreenProps) => {

    return (
        <div className={styles.successScreen}>
            <Row className="justify-content-center">
                <Col xs={12}>
                    <h2 className={styles.subtitle}>Извините, произошла ошибка!</h2>
                    <p className={styles.text}>Попробуйте, пожалуйста, еще раз.</p>
                </Col>
            </Row>
            <Row>
                <Col lg={{ span: 6, offset: 6 }}>
                    <ButtonPrimary type="submit" className={styles.buttonClose} onClick={handleClose}>
                        <>
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M19.5 6.41L18.09 5L12.5 10.59L6.91 5L5.5 6.41L11.09 12L5.5 17.59L6.91 19L12.5 13.41L18.09 19L19.5 17.59L13.91 12L19.5 6.41Z" fill="currentColor" />
                            </svg>
                            <span>Закрыть</span>
                        </>
                    </ButtonPrimary>
                </Col>
            </Row>
        </div>
    );
}

const RequestModal = ({open, handleClose, hasComment}: RequestModalProps) => {

    const [isSuccess, setIsSuccess] = React.useState(false);
    const [isError, setIsError] = React.useState(false);

    const closeModal = () => {
        handleClose();
        setIsSuccess(false);
        setIsError(false);
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="Заявка на доступ"
        >
            <div className={styles.modal}>
                <Row className={cx("justify-content-between align-items-center", styles.titleContainer)}>
                    <Col xs={10} sm={9} className="p-0">
                        <h1 className={styles.title}>{hasComment ? 'Предложения и вопросы' : 'Заявка на доступ'}</h1>
                    </Col>
                    <Col xs={1} sm={2} className="p-0">
                        <button className={styles.closeButton} onClick={handleClose} type="button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                <path d="M25.3332 8.54699L23.4532 6.66699L15.9998 14.1203L8.5465 6.66699L6.6665 8.54699L14.1198 16.0003L6.6665 23.4537L8.5465 25.3337L15.9998 17.8803L23.4532 25.3337L25.3332 23.4537L17.8798 16.0003L25.3332 8.54699Z" fill="currentColor" />
                            </svg>
                        </button>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} className="p-0">
                        <ArrowBg key={`${isSuccess}-${isError}`}>
                            <div className={styles.form}>
                                {isSuccess && <SuccessScreen handleClose={closeModal}/>}
                                {isError && <ErrorScreen handleClose={closeModal}/>}
                                {!isSuccess && !isError &&
                                    <ContactForm
                                        isModal
                                        onSuccess={(value) => setIsSuccess(value)}
                                        onError={(value) => setIsError(value)}
                                        hasComment={hasComment}
                                    />}
                            </div>
                        </ArrowBg>
                    </Col>
                </Row>
            </div>
        </Modal>
    );
}

export default RequestModal;
